import { motion } from "framer-motion";
import { Brain, ShieldCheck, Gauge, Lock, BarChart3 } from "lucide-react";

const features = [
  {
    icon: Brain,
    title: "Smart Matching",
    description: "Only see founders and investors that fit your actual criteria. No noise, no irrelevant pitches.",
  },
  {
    icon: ShieldCheck,
    title: "Everyone's Verified",
    description: "KYC-backed profiles mean every person you meet is real, serious, and accountable.",
  },
  {
    icon: Gauge,
    title: "Fast by Design",
    description: "You can review a full pipeline in the time it used to take to write one cold email.",
  },
  {
    icon: Lock,
    title: "Your Privacy, Your Rules",
    description: "You decide what to share and when. Nothing goes public without your say-so.",
  },
  {
    icon: BarChart3,
    title: "Live Deal Insights",
    description: "See who's viewed your profile, track investor interest, and follow deal progress in real time.",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-24 md:py-32" aria-label="Platform features">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-xs font-medium text-primary/80 uppercase tracking-widest mb-3">Features</p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            Everything you need to{" "}
            <span className="text-gradient">close your round</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            One platform for discovery, introductions, and closing, so you can spend less time searching and more time building.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {features.map((feat, i) => (
            <motion.div
              key={feat.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="rounded-xl bg-card/70 backdrop-blur-xl p-6 group transition-all duration-300 teal-ring-hover cursor-default"
              style={{ border: "1px solid hsl(174 65% 45% / 0.12)" }}
            >
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/10 flex items-center justify-center mb-4 border border-primary/15 group-hover:shadow-[0_0_20px_hsl(174_65%_45%/0.25)] transition-shadow">
                <feat.icon className="w-5 h-5 text-primary" aria-hidden="true" />
              </div>
              <h3 className="font-display font-semibold mb-2">{feat.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feat.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
